import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chatterbug/aaron'

const UnitVocabularySkeleton = ({ headerSection, listSection }) => {
  return (
    <Box>
      <Box>{headerSection}</Box>
      <Box
        mt="2x"
        padding="2x"
        borderRadius="1,5x"
        boxShadow="overlay"
        backgroundColor="white100"
      >
        {listSection}
      </Box>
    </Box>
  )
}

UnitVocabularySkeleton.propTypes = {
  headerSection: PropTypes.any,
  listSection: PropTypes.any,
}

export default UnitVocabularySkeleton
